export default "__VITE_ASSET__4BuwGLYv__"